import { render, staticRenderFns } from "./Slidebar.vue?vue&type=template&id=765663fa"
import script from "./Slidebar.vue?vue&type=script&lang=js"
export * from "./Slidebar.vue?vue&type=script&lang=js"
import style0 from "./Slidebar.vue?vue&type=style&index=0&id=765663fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports